import { quickStats, filmProfile } from "@/mocks/film";

export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="top" className="relative w-full min-h-[600px] md:min-h-[760px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20moody%20cinematic%20interior%20of%20a%20quiet%20apartment%20living%20room%20at%20golden%20hour%2C%20sheer%20linen%20curtains%20glowing%20with%20amber%20sunlight%2C%20soft%20dust%20particles%20in%20the%20air%2C%20deep%20warm%20brown%20shadows%2C%20terracotta%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20elegant%20editorial%20film%20still%20aesthetic%2C%20rich%20contrast%2C%20high%20detail&width=1920&height=1080&seq=film-hero-2026-01&orientation=landscape"
          alt="暖色调的电影室内空镜，作为影片主题的视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/35" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-36 pb-20 md:pt-44 md:pb-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/12 border border-background-50/25 text-primary-200 text-xs font-label tracking-wide backdrop-blur">
            <i className="ri-price-tag-3-line" aria-hidden="true" />
            家庭伦理 · 都市情感 · 剧情片
          </span>

          <h1 className="font-heading mt-6 text-4xl md:text-6xl font-black leading-tight text-background-50">
            漂亮的小姨子
          </h1>
          <p className="mt-4 text-base md:text-lg text-background-100/90 font-label tracking-wide">
            剧情介绍 · 角色关系 · 演员表 · 分幕解说，一页读完这部温和的家庭伦理片
          </p>

          <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-background-200/90">
            {filmProfile.intro}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={() => scrollTo("plot")}
              className="inline-flex items-center justify-center gap-2 px-6 h-12 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line text-base" aria-hidden="true" />
              查看剧情介绍
            </button>
            <button
              type="button"
              onClick={() => scrollTo("cast")}
              className="inline-flex items-center justify-center gap-2 px-6 h-12 rounded-md bg-background-50/12 border border-background-50/30 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              <i className="ri-group-line text-base" aria-hidden="true" />
              浏览角色与演员表
            </button>
          </div>

          <dl className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {quickStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur px-4 py-3"
              >
                <dt className="flex items-center gap-1.5 text-[11px] text-background-200/80 font-label">
                  <i className={`${stat.icon} text-primary-300`} aria-hidden="true" />
                  {stat.label}
                </dt>
                <dd className="mt-1.5 text-sm md:text-base font-semibold text-background-50">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}